<div class="basin-blurred-background-mask" *ngIf="isPageVisible">
    <div class="basin-gradient-blue-to-bottom load-gradient-background p-d-flex p-jc-center p-ai-center">
        <basin-lottie-animation-player [height]="'60px'" [width]="'60px'" [path]="'/assets/StantecSpinnerWhite.json'"
            [autoplay]="true" [loop]="true"></basin-lottie-animation-player>
    </div>
</div>

<div *ngIf="isEnterpriseDataAvailable">
    <app-license-details [config]="detailsConfig"
        (actionTriggered)="handleLicenseDetailAction($event.action, $event)"></app-license-details>
</div>

<div class="basin-pt-4 basin-pb-4 basin-mt-4" *ngIf="isEnterpriseDataAvailable">
    <p-tabView class="basin-pt-4 basin-pb-4">
        <p-tabPanel header="Users ({{totalRecords}})" class="basin-pt-4">
            <p-card class="basin-mt-2">
                <div class="tabpanel-content ">
                    <div class="basin-flex-row basin-display-flex basin-align-items-center basin-width-100 basin-mb-4">
                        <button class="p-button p-button-text basin-mr-4" [disabled]="(isMaxUsersReached)"
                            aria-label="Add Users" (click)="openAddManager('user')" *ngIf="!isLicenseTier3">
                            <span class="icon-group-add basin-mr-1"></span> Add Users
                        </button>

                        <button class="p-button p-button-text basin-mr-4" *ngIf="isLicenseTier3" aria-label="Add Users"
                            [disabled]="(isMaxUsersReached)" (click)="openAddManager('user')">
                            <span class="icon-group-add basin-mr-1"></span> Add Users
                        </button>
                    </div>

                    <div *ngIf="!isLicenseTier3" class="selected-label-text basin-mt-2">
                        <p>
                        Users remaining in your tier license:
                        <span class="highlight-selected-label-text">{{ remainingUsers }}</span>.
                        <span *ngIf="isMaxUsersReached" class="basin-mt-1 basin-display-block">                          
                            To add more users under the Enterprise License, a tier upgrade is required.
                            Please submit a request via the DebrisFlow Predictor
                            <a href="https://stantecdigitalservices.atlassian.net/servicedesk/customer/portal/29/group/134/create/594"
                                target="_blank" title="Open Help Desk in a new tab" rel="noopener noreferrer">Help
                                Desk</a>.
                        </span>
                        </p>
                    </div>
                    <basin-searchbox class="basin-mt-2 basin-pb-4" [searchString]="searchString"
                        (searchStringChange)="onSearchChange($event)"></basin-searchbox>

                    <app-data-grid *ngIf="userTableConfig" [config]="userTableConfig" [totalRecords]="totalRecords"
                        (actionTriggered)="handleAction($event.action, $event.row)">
                    </app-data-grid>
                </div>
            </p-card>
        </p-tabPanel>

        <p-tabPanel header="Study Area ({{totalArea}})">
            <p-card>
                <p *ngIf="!isLicenseTier3" class="selected-label-text">
                    Current total :
                    <span class="highlight-selected-label-text"> {{ totalStudyAreasDisplay }}</span> sq km.<br />
                    Available in tier : <span class="highlight-selected-label-text"> {{
                        remainingAreaDisplay }}</span> sq km.
                </p>
                <basin-searchbox class="basin-mt-2 basin-pb-4" [searchString]="studySearchString"
                    (searchStringChange)="onStudyAreaChange($event)"></basin-searchbox>

                <app-data-grid *ngIf="studyAreaTableConfig" [config]="studyAreaTableConfig"
                    [totalRecords]="totalStudyAreaRecords" (actionTriggered)="handleAction($event.action, $event.row)">
                </app-data-grid>
            </p-card>
        </p-tabPanel>
    </p-tabView>
</div>
